<template>
  <div class="backdrop">
    <div class="title-box">
      <img src="../../../assets/images/return.png" @click="$router.go(-1)"><span>资产盘点</span><img src="../../../assets/images/material-add.png" @click="$router.push({name: 'AssetStocktakingAdd'})">
    </div>
    <div class="common search-box">
      <input type="text" placeholder="请输入物品名称/条码" v-model="search_input">
      <div @click="getList()">搜索</div>
    </div>
    <div class="date-wrapper common">
      <span class="title">日期</span>
      <span>
        <img src="../../../assets/images/repair-left-arrow.png" @click="lastday1(date_time1)">
        <div @click="selectData1">{{date_time1}}</div>
        <mt-datetime-picker ref="datePicker1" type="date" v-model="pickerValue1" @confirm="handleConfirm1"></mt-datetime-picker>
        <img src="../../../assets/images/repair-right-arrow.png" @click="nextday1(date_time1)">
      </span>
      <span class="division">至</span>
      <span>
        <img src="../../../assets/images/repair-left-arrow.png" @click="lastday2(date_time2)">
        <div @click="selectData2">{{date_time2}}</div>
        <mt-datetime-picker ref="datePicker2" type="date" v-model="pickerValue2" @confirm="handleConfirm2"></mt-datetime-picker>
        <img src="../../../assets/images/repair-right-arrow.png" @click="nextday2(date_time2)">
      </span>
    </div>
    <div class="common order-wrapper">
      <div class="block">
        <div class="item">
          <span class="total">合计</span>
          <input type="checkbox" id="w_total" :checked="checkedAll == true" @click="isCheckedAll(checkedAll)">
          <label for="w_total" style="background-position: 50px 9px;"><span style="padding-left: 70px;">全选</span></label>
          <div><span>{{total_count}}</span>笔</div>
        </div>
      </div>
      <div class="block">
        <div class="item">
          <input type="checkbox" id="w_norecorded" :checked="checkeds.indexOf(1) >= 0" @click="isChecked(1)">
          <label for="w_norecorded"><span>未入账</span></label>
          <div><span class="orange">{{not_enter_count}}</span>笔</div>
        </div>
      </div>
      <div class="block">
        <div class="item">
          <input type="checkbox" id="w_recorded" :checked="checkeds.indexOf(2) >= 0" @click="isChecked(2)">
          <label for="w_recorded"><span>已入账</span></label>
          <div><span class="green">{{enter_count}}</span>笔</div>
        </div>
      </div>
    </div>
    <div class="orderlist-wrapper">
      <div class="order-row mar_bot" v-for="(stocktaking, stocktaking_key) in stocktaking_list" :key="stocktaking_key">
        <div class="layout mar_bot top">
          <div class="flex-1">{{stocktaking.stocktaking_title}}</div>
          <div class="status background_green" v-if="stocktaking.status === 1">已入账</div>
          <div class="status background_red" v-else>未入账</div>
          <!-- <div class="more"><img src="../../../assets/images/asset-more.png"></div> -->
        </div>
        <div class="center" @click="toDetail(stocktaking.stocktaking_id)">
          <div class="layout mar_bot">
            <div class="flex-1"><label>创建人</label>{{stocktaking.create_member_name}}</div>
            <div class="flex-1"><label>盘点总数</label>{{stocktaking.total_rows}}</div>
          </div>
          <div class="layout mar_bot">
            <div class="flex-1"><label>创建时间</label>{{stocktaking.create_time_info}}</div>
            <div class="flex-1"><label>盘点仓库</label>{{stocktaking.storage_name}}</div>
          </div>
          <div class="layout mar_bot">
            <div class="flex-1"><label>入账时间</label>{{stocktaking.enter_time_info}}</div>
          </div>
        </div>
        <div class="layout bottom" @click="toDetail(stocktaking.stocktaking_id)">
          <div class="flex-1">
            <label>待盘点<img src="../../../assets/images/asset-right_jt.png"></label>
            <div class="num">{{stocktaking.wait_rows}}</div>
          </div>
          <div class="flex-1">
            <label>盘平<img src="../../../assets/images/asset-right_jt.png"></label>
            <div class="num">{{stocktaking.balance_rows}}</div>
          </div>
          <div class="flex-1">
            <label>盘盈<img src="../../../assets/images/asset-right_jt.png"></label>
            <div class="num">{{stocktaking.profit_rows}}</div>
          </div>
          <div class="flex-1">
            <label>盘亏<img src="../../../assets/images/asset-right_jt.png"></label>
            <div class="num">{{stocktaking.loss_rows}}</div>
          </div>
        </div>
        <div class="approval-row" v-if="stocktaking.approval">
          <div class="flex-1" style="color:blue" @click="$router.push({name: 'ApprovalInfo', query: {approval_id: stocktaking.approval.approval_id}})">{{stocktaking.approval.approval_status_name}}</div>
        </div>
      </div>
      <div v-if="see_more" @click="getList(2)" class="more">- 点击查看更多 -</div>
    </div>
    <!-- 加载动画 -->
    <div class="loading" v-if="loading">
      <img src="../../../assets/images/loading.gif">
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'AssetStocktakingList',
  metaInfo: {
    title: '资产盘点'
  },
  data () {
    return {
      loading: false, // 加载动画
      date_time1: '',
      date_time2: '',
      pickerValue1: new Date(),
      pickerValue2: new Date(),
      checkedAll: true, // 默认全选状态
      checkeds: [1, 2],
      allcheckeds: [1, 2],
      stocktaking_list: [],
      total_count: 0,
      enter_count: 0,
      not_enter_count: 0,
      search_input: '',
      page: 0, // 页码
      see_more: false // 点击查看更多
    }
  },
  computed: {
    ...mapState(['villageId', 'memberId'])
  },
  created () {
    this.date_time1 = this.getDate()
    this.date_time2 = this.getDate()
    this.getList()
  },
  methods: {
    // 获取当前时间
    getDate (type) {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      return `${year}-${month}-${day}`
    },
    // 打开时间选择器
    selectData1 () {
      this.$refs['datePicker1'].open()
      let a = document.getElementsByClassName('picker-solt')
      console.log(a.length)
      for (let i = 0; i < a.length; i++) {
        console.log(i)
        if (i === 2) {
          a[i].style.display = 'none'
        }
      }
    },
    // 打开时间选择器
    selectData2 () {
      this.$refs['datePicker2'].open()
      let a = document.getElementsByClassName('picker-solt')
      console.log(a.length)
      for (let i = 0; i < a.length; i++) {
        console.log(i)
        if (i === 2) {
          a[i].style.display = 'none'
        }
      }
    },
    // 选择时间点击确定按钮
    handleConfirm1 (val) {
      let date = val
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      let resDate = year + '-' + month + '-' + day
      this.date_time1 = resDate
      this.getList()
    },
    // 选择时间点击确定按钮
    handleConfirm2 (val) {
      let date = val
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      let resDate = year + '-' + month + '-' + day
      this.date_time2 = resDate
      this.getList()
    },
    // 上一个天
    lastday1 (type) {
      var date = new Date(type)
      date.setDate(date.getDate() - 1)
      var y = date.getFullYear()
      var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      this.date_time1 = y + '-' + m + '-' + d
      this.getList()
      return y + '-' + m + '-' + d
    },
    // 下一个天
    nextday1 (type) {
      var date = new Date(type)
      date.setDate(date.getDate() + 1)
      var y = date.getFullYear()
      var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      this.date_time1 = y + '-' + m + '-' + d
      this.getList()
      return y + '-' + m + '-' + d
    },
    // 上一个天
    lastday2 (type) {
      var date = new Date(type)
      date.setDate(date.getDate() - 1)
      var y = date.getFullYear()
      var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      this.date_time2 = y + '-' + m + '-' + d
      this.getList()
      return y + '-' + m + '-' + d
    },
    // 下一个天
    nextday2 (type) {
      var date = new Date(type)
      date.setDate(date.getDate() + 1)
      var y = date.getFullYear()
      var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      this.date_time2 = y + '-' + m + '-' + d
      this.getList()
      return y + '-' + m + '-' + d
    },
    // 是否全选
    isAllCheckeds: function () {
      if (this.checkeds.length === this.allcheckeds.length) {
        this.checkedAll = true
      } else {
        this.checkedAll = false
      }
    },
    // 全选
    isCheckedAll (checkedAll) {
      if (checkedAll === true) {
        this.checkedAll = false
        this.checkeds = []
      } else {
        this.checkedAll = true
        this.checkeds = [1, 2]
      }
      this.getList()
    },
    isChecked (checkedId) {
      let Index = this.checkeds.indexOf(checkedId)
      if (Index >= 0) {
        // 如果已经包含了该id, 则去除(单选按钮由选中变为非选中状态)
        this.checkeds.splice(Index, 1)
      } else {
        // 选中该checkbox
        this.checkeds.push(checkedId)
      }
      console.log(this.checkeds)
      this.isAllCheckeds() // 是否全选
      this.getList()
    },
    // 获取盘点单列表
    getList (type = 1) {
      this.loading = true
      var stocktakingList = this.stocktaking_list
      if (type === 2) {
        // 查看更多
      } else {
        // 搜索条件有变化，需重新获取列表 和 统计数据
        this.stocktaking_list = []
        this.page = 0
        this.total_count = 0
        this.enter_count = 0
        this.not_enter_count = 0
        stocktakingList = []
        // 统计数据
        this.axios.post('/wechat/stocktaking/stocktakingList', {
          member_id: this.memberId,
          village_id: this.villageId,
          type: 2,
          start_time: this.date_time1,
          end_time: this.date_time2,
          goods_keywords: this.search_input
        }).then((res) => {
          if (res.data.status === 1) {
            this.total_count = res.data.data.total
            this.enter_count = res.data.data.total_enter
            this.not_enter_count = res.data.data.total_not_enter
          }
        })
      }
      // 列表分页数据
      if (this.checkeds.length === 0) {
        this.stocktaking_list = []
        this.page = 0
        this.see_more = false
        this.loading = false
      } else {
        this.axios.post('/wechat/stocktaking/stocktakingList', {
          member_id: this.memberId,
          village_id: this.villageId,
          type: 2,
          start_time: this.date_time1,
          end_time: this.date_time2,
          goods_keywords: this.search_input,
          status_checkeds: this.checkeds.join(','),
          page: this.page + 1
        }).then((res) => {
          if (res.data.status === 1) {
            this.stocktaking_list = stocktakingList.concat(res.data.data.stocktaking_list)
            this.page = res.data.data.page
            if (this.stocktaking_list.length >= res.data.data.total) {
              this.see_more = false
            } else {
              this.see_more = true
            }
            this.loading = false
          } else {
            this.loading = false
            this.$toast({
              message: res.data.info,
              duration: 5000
            })
          }
        }).catch(() => {
          this.loading = false
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
      }
    },
    // 详情
    toDetail: function (stocktakingId) {
      this.$router.push({name: 'AssetStocktakingInfo', query: {stocktaking_id: stocktakingId}})
    }
  }
}
</script>
<style scoped>
.common {
  padding: 15px 10px;
}
.date-wrapper {
  font-size: 15px;
  color: #000000;
  padding-top: 0;
}
.date-wrapper .title {
  padding-right: 10px;
}
.date-wrapper .division {
  padding: 0 5px;
}
.date-wrapper span {
  line-height: 18px;
}
.date-wrapper img {
  width: 18px;
  height: 18px;
  vertical-align: top;
}
.date-wrapper div {
  display: inline-block;
  padding: 0 2px;
}
.order-wrapper {
  display: flex;
  font-size: 14px;
}
.order-wrapper .block {
  flex: 1;
}
.order-wrapper .block .item {
  margin: 0 4px;
  background-color: #f4f4f4;
  position: relative;
  padding: 0 5px;
}
.order-wrapper .block .item input {
  position: absolute;
  top: 0;
  left: 0;
  visibility: hidden;
}
.order-wrapper .block .item input:checked+label {
  background-image: url(../../../assets/images/checked.png);
}
.order-wrapper .block .item label {
  background-repeat: no-repeat;
  background-image: url(../../../assets/images/unchecked.png);
  background-position: 5px 9px;
  background-size: 16px 16px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.order-wrapper .block .item label span:last-child {
  padding: 7px 0 0 26px;
  display: block;
}
.order-wrapper .block .item div {
  padding: 30px 0 5px 0;
}
.order-wrapper .block .item div span {
  font-size: 17px;
  font-weight: 700;
  padding-right: 4px;
}
.order-wrapper .block .item .total {
  position: absolute;
  top: 7px;
  left: 5px;
}
.orderlist-wrapper {
  color: #313131;
  font-size: 13px;
}
.orderlist-wrapper .order-row {
  background-color: #ffffff;
}
.orderlist-wrapper .layout {
  display: flex;
}
.orderlist-wrapper .layout .flex-1 {
  flex: 1;
}
.orderlist-wrapper .layout .more {
  padding: 0;
}
.orderlist-wrapper .layout .more img {
  width: 20px;
  height: 20px;
}
.orderlist-wrapper .order-row .top {
  border-bottom: 1px solid #f4f4f4;
  padding: 10px;
  font-size: 15px;
}
.orderlist-wrapper .order-row .top .flex-1 {
  font-weight: bold;
}
.orderlist-wrapper .order-row .center {
  border-bottom: 1px solid #f4f4f4;
  padding: 0 10px;
}
.orderlist-wrapper .order-row .center label {
  color: #999;
  display: inline-block;
  width: 64px;
}
.orderlist-wrapper .order-row .approval-row {
  border-top: 1px solid #f4f4f4;
  padding: 10px;
}
.orderlist-wrapper .order-row .approval-row label {
  color: #999;
  display: inline-block;
  width: 64px;
}
.orderlist-wrapper .order-row .bottom {
  padding: 10px;
}
.orderlist-wrapper .order-row .bottom .flex-1 {
  text-align: center;
}
.orderlist-wrapper .order-row .bottom label {
  color: #999;
}
.orderlist-wrapper .order-row .bottom label img {
  width: 9px;
  height: 9px;
  padding-left: 3px;
}
.orderlist-wrapper .order-row .bottom .num {
  font-size: 16px;
  margin-top: 10px;
  font-weight: 600;
}
.orderlist-wrapper .layout .status {
  color: #fff;
  padding: 0 9px;
  border-radius: 12px;
  font-size: 14px;
  display: inline-block;
}
.background_green {
  background-color: #35c53b;
}
.background_red {
  background-color: #ff5148;
}
.mar_bot {
  margin-bottom: 8px;
}
.orderlist-wrapper .more {
  font-size: 14px;
  text-align: center;
  background-color: #ffffff;
  padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/AssetStocktaking/AssetStocktakingList.vue